import React, { useCallback, useEffect } from 'react';
import s from './s.module.less';
import { Form, Select, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import CredentialTip from 'assets/channel/credentialTip.jpg';
// import useGetSettingData from 'hooks/useGetSettingData';
import { EnumFields } from 'types/enumerationData';
import useSettings from 'hooks/useSettings';
import { ISaveBasicInfo } from 'types/ppaOnboarding';
import { IBasicInfoStep } from 'types/newUniprofile';

interface IProps {
    setNextButtonDisabled: (disabled: boolean) => void;
    formId: string;
    onNext: (data: ISaveBasicInfo) => void;
    initValue?: IBasicInfoStep | null;
    wrapClassName?: string;
}

const Step3 = ({ setNextButtonDisabled, formId, onNext, initValue, wrapClassName }: IProps) => {
    const [form] = Form.useForm();
    const [setting] = useSettings();
    const credentialTypesOptions = setting[EnumFields.CREDENTIAL_TYPE] || [];
    const credentialsVal = Form.useWatch('credential', form);

    useEffect(() => {
        if (initValue) {
            form.setFieldsValue({
                credential: (initValue.credential as string)?.split(','),
            });
        }
    }, [initValue, form]);

    useEffect(() => {
        setNextButtonDisabled(!credentialsVal || credentialsVal.length === 0);
    }, [credentialsVal, setNextButtonDisabled]);

    const handleNext = useCallback(
        async (values: Partial<ISaveBasicInfo>) => {
            if (Array.isArray(values.credential)) {
                values.credential = values.credential.join(',');
            }
            onNext?.(values);
        },
        [onNext],
    );

    return (
        <div className={`${s.wrap} ${wrapClassName || ''}`}>
            <h2>What are your credentials?</h2>
            <p>Shown on your profile to highlight your qualifications.</p>

            <div className={s.formContainer}>
                <Form layout="vertical" form={form} onFinish={handleNext} id={formId}>
                    <Form.Item
                        label={
                            <div className={s.labelWithIcon}>
                                <span>Credentials</span>
                                <Tooltip
                                    trigger={['click', 'hover']}
                                    overlayClassName={s.tipCard}
                                    overlayInnerStyle={{ padding: '24px' }}
                                    color="#FFFFFF"
                                    title={
                                        <div className={s.tipText}>
                                            Credentials will appear right next to your name.
                                            <img src={CredentialTip} />
                                        </div>
                                    }
                                >
                                    <QuestionCircleOutlined className={s.helpIcon} />
                                </Tooltip>
                            </div>
                        }
                        name="credential"
                        rules={[{ required: true, message: 'Please select your credentials!' }]}
                    >
                        <Select placeholder="Select credentials" mode="multiple" options={credentialTypesOptions} />
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default Step3;
